import React, { useEffect } from "react";
import AOS from "aos";
import SEO from "../../SEO";
import "./BillingSoftware.css";

export default function BillingSoftware() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100, once: true });
  }, []);

  const features = [
    { icon: "🧾", text: "Fast Billing & Invoicing System" },
    { icon: "🛒", text: "POS Integration Support" },
    { icon: "📦", text: "Inventory Management Sync" },
    { icon: "💳", text: "Multiple Payment Methods" },
    { icon: "🏷️", text: "Barcode Scanning Support" },
    { icon: "📊", text: "Real-Time Sales Reports" },
    { icon: "👥", text: "Customer Management System" },
    { icon: "🔐", text: "Secure Transaction Handling" },
  ];

  const benefits = [
    { icon: "⚡", text: "Faster Billing Process" },
    { icon: "💰", text: "Increase Sales Efficiency" },
    { icon: "📉", text: "Reduce Human Errors" },
    { icon: "📈", text: "Better Business Insights" },
    { icon: "🚀", text: "Boost Operational Speed" },
    { icon: "🏆", text: "Enterprise-Level System" },
  ];

  const industries = [
    { icon: "🛒", text: "Retail Billing System" },
    { icon: "💊", text: "Pharmacy POS System" },
    { icon: "🏪", text: "Supermarket Billing Software" },
    { icon: "🍽️", text: "Restaurant Billing System" },
    { icon: "👕", text: "Garments Store POS" },
    { icon: "🏭", text: "Wholesale Billing System" },
    { icon: "🚚", text: "Distribution Companies" },
    { icon: "🛍️", text: "E-Commerce Billing System" },
  ];

  const faqs = [
    {
      q: "What is billing software?",
      a: "Billing software is used to generate invoices, manage sales, and track payments in real-time.",
    },
    {
      q: "Does it include POS system?",
      a: "Yes, our billing software is fully integrated with POS systems.",
    },
    {
      q: "Can it manage inventory?",
      a: "Yes, it syncs with inventory for real-time stock updates.",
    },
    {
      q: "Is it suitable for retail businesses?",
      a: "Yes, it is widely used in retail, pharmacy, and supermarket businesses.",
    },
  ];

  return (
    <>
      <SEO
        title="Billing Software | POS & Inventory System Pakistan"
        description="Advanced billing software for retail, pharmacy, supermarket and ERP systems with POS integration in Pakistan."
        url="https://mzrsoftware.com/billing-software"
      />

      <div className="billing-section">
        {/* HERO */}
        <section className="hero text-center" data-aos="fade-up">
          <h1>
            Billing <span>Software</span>
          </h1>
          <p>
            Smart billing and invoicing system with POS integration, inventory
            management and real-time reporting for retail and business
            automation.
          </p>
        </section>

        {/* INTRO */}
        <section className="section text-center" data-aos="fade-up">
          <h2>Introduction</h2>
          <p>
            Our billing software helps businesses automate invoicing, speed up
            checkout, and manage sales efficiently with integrated ERP & POS
            systems.
          </p>
        </section>

        {/* FEATURES */}
        <section className="section">
          <h2 className="text-center">Features</h2>

          <div className="grid">
            {features.map((f, i) => (
              <div
                className="card"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 50}
              >
                <div className="icon">{f.icon}</div>
                <h3>{f.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* BENEFITS */}
        <section className="section">
          <h2 className="text-center">Benefits</h2>

          <div className="grid">
            {benefits.map((b, i) => (
              <div className="card" key={i} data-aos="zoom-in">
                <div className="icon">{b.icon}</div>
                <h3>{b.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* SCREENSHOTS */}
        <section className="section text-center">
          <h2>Screenshots</h2>

          <div className="grid">
            <div className="card">🧾 Billing Dashboard</div>
            <div className="card">💳 POS Checkout Screen</div>
            <div className="card">📊 Sales Report Panel</div>
          </div>
        </section>

        {/* INDUSTRIES */}
        <section className="section">
          <h2 className="text-center">Industries</h2>

          <div className="grid">
            {industries.map((ind, i) => (
              <div className="card" key={i}>
                <div className="icon">{ind.icon}</div>
                <h3>{ind.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="section">
          <h2 className="text-center">FAQs</h2>

          <div className="grid">
            {faqs.map((faq, i) => (
              <div className="card" key={i}>
                <h3>{faq.q}</h3>
                <p>{faq.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="cta text-center" data-aos="fade-up">
          <h2>Upgrade Your Billing System Today</h2>
          <p>
            Get a fast, secure and modern billing software with POS & ERP
            integration for your business.
          </p>

          <a href="/contact" className="btn">
            Get Free Consultation →
          </a>
        </section>
      </div>
    </>
  );
}
